import { render, staticRenderFns } from "./OpakovaniHistorie.vue?vue&type=template&id=e10e9586&scoped=true&"
import script from "./OpakovaniHistorie.vue?vue&type=script&lang=js&"
export * from "./OpakovaniHistorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10e9586",
  null
  
)

export default component.exports